import { Alert, Slide, Snackbar } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  deleteProduct,
  closeDeleteModal,
} from "../../../feature/products/deleteProductSlice";

import {
  closeViewModal,
  // getProducts,
} from "../../../feature/products/productDetailSlice";

const ProductModals = () => {
  const dispatch = useDispatch();

  const {
    isDeleteModalOpen,
    viewSingleProduct,
    deleteProductError,
    deleteProductStatus,
  } = useSelector((state) => state.deleteProducts);

  const {
    isViewModalOpen,
    imageUrl,
    productDetails: productData,
  } = useSelector((state) => state.productDetails);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleDelete = (id) => {
    dispatch(deleteProduct(viewSingleProduct.id));
  };

  const ViewProductModal = () => {
    return (
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={isViewModalOpen}
        onClose={() => dispatch(closeViewModal())}
      >
        <DialogTitle> {productData[0]?.id} </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            ID:{productData[0]?.id}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Category ID:{productData[0]?.category_id}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Product: {productData[0]?.product_name}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Product Brand: {productData[0]?.product_brand}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Product Amount: {productData[0]?.product_amount}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Product Discount Price: {productData[0]?.product_discount_price}
          </DialogContentText>
          <DialogContentText>
            Product Image:
            <img
              src={imageUrl + productData[0]?.product_image}
              alt=''
              style={{
                display: "flex",
                marginRight: "10px",
                maxHeight: 80,
                maxWidth: 80,
              }}
            />
          </DialogContentText>
          <DialogContentText>Product Multi Image:</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color='secondary'
            onClick={() => dispatch(closeViewModal())}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const DeleteConfirmationModal = () => {
    return (
      <>
        <Dialog open={isDeleteModalOpen}>
          <DialogTitle>Delete {viewSingleProduct.product_name} </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Are you sure you want to delete this order?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color='error'
              onClick={() => {
                handleDelete();
                handleClick();
                // dispatch(deleteProduct(viewSingleProduct.id));
              }}
            >
              Delete
            </Button>
            <Button
              color='secondary'
              onClick={() => dispatch(closeDeleteModal())}
              autoFocus
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        {deleteProductStatus === "rejected" ? (
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            TransitionComponent={Slide}
            transitionDuration={{ enter: 1000, exit: 4000 }}
            TransitionProps={{ enter: true, exit: false }}
          >
            <Alert severity='error'>{deleteProductError}</Alert>
          </Snackbar>
        ) : null}
        {deleteProductStatus === "success" ? (
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            TransitionComponent={Slide}
            transitionDuration={{ enter: 1000, exit: 4000 }}
            TransitionProps={{ enter: true, exit: false }}
          >
            <Alert severity='success'>Product is deleted...</Alert>
          </Snackbar>
        ) : null}
      </>
    );
  };

  return (
    <>
      <ViewProductModal />
      <DeleteConfirmationModal />
    </>
  );
};

export default ProductModals;
